import { useRef, useState } from 'react'
import Login from '../Login/Login'
import Signup from '../Signup/Signup'
import './Register.css'

const Register = () => {
  const [login, setLogin] = useState(true)

  const RegisterRef = useRef(null)

  const handleClick = () => {
    setLogin(!login)

    RegisterRef.current.classList.toggle('active')
  }

  return (
    <div>
      <div className="area">
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>

      <div className="RegisterContainer" ref={RegisterRef}>
        <Login />
        <div className="side-div">
          <button type="button" onClick={handleClick}>
            {' '}
            {login ? 'Signup' : 'Login'}
          </button>
        </div>
        <Signup />
      </div>
    </div>
  )
}

export default Register
